// extracted by mini-css-extract-plugin
export default {"title":"ProductFeatureBoxList-module--title--mAQvB","noBottomWhitespace":"ProductFeatureBoxList-module--noBottomWhitespace--XtxvH"};